import { useCallback, useState } from 'react';

import { twm } from '../../core/themes/tw-merge';
import { useOnClickOutside } from '../hooks';
import { QuestionCircleIcon } from '@frontend/shared/icons';

type Props = {
  text: string;
};

export const InfoPopover = ({ text }: Props) => {
  const [isVisible, setIsVisible] = useState(false);

  const ref = useOnClickOutside(
    useCallback(() => {
      setIsVisible(false);
    }, []),
  );

  return (
    <div className="relative w-5 h-5">
      <button type="button" onClick={() => setIsVisible(true)} className="cursor-pointer">
        <QuestionCircleIcon />
      </button>
      <div
        ref={ref}
        role="tooltip"
        className={twm(
          'absolute z-10 inline-block w-64 px-3 py-2 text-body-sm leading-lh-body-sm text-text-secondary transition-opacity duration-300 bg-surface-primary border border-border-secondary rounded-md shadow-md',
          !isVisible && 'invisible opacity-0',
        )}
      >
        <p>{text}</p>
      </div>
    </div>
  );
};
